import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import classes from './TypeOfFabric.module.css';
import Placeholder from '../../UI/Placeholder/Placeholder';
import SettingsForm from '../SettingsForm/SettingsForm';
import useForm from '../../../hooks/useForm';
import SettingsList from '../SettingsList/SettingsList';
import { AlertType, FabricType } from '../../../types/common';
import Card from '../../UI/Card/Card';
import { createFabricType, deleteFabricType, removeSelectedFabricType, selectFabricType, updateFabricType } from '../../../store/FabricTypeSlice';
import IconButton from '../../UI/IconButton/IconButton';
import AddIcon from '../../UI/icons/AddIcon/AddIcon';
import { showAlert } from '../../../store/CommonSlice';
import { DELETE_FABRICTYPE_ALERT_MESSAGE, NO_TYPESOFFABRIC_MESSAGE } from '../../../constants/messages';
import AreaLoader from '../../UI/AreaLoader/AreaLoader';
import { updateAllProductsTypesOfFabric } from '../../../store/ProductSlice';
import { fabricTypeFormValidator } from '../../../utils/validators';

const INIT_INPUT = {
    name: '',
    description: '',
    url: '',
};

const TypeOfFabric: React.FC = () => {
    const { isLoading, typesOfFabric, error } = useSelector((state: RootState) => state.fabricType);
    const { products } = useSelector((state: RootState) => state.product);
    const fabricTypeToBeEdited = useSelector((state: RootState) => state.fabricType.selectedFabricType);
    const dispatch = useDispatch<AppDispatch>();
    const [isFormOpen, setIsFormOpen] = useState(false);
    const { input, setInput, handleChange, errors, submit, resetForm } = useForm<
        typeof INIT_INPUT,
        string | { [key: string]: string } // Уточняем тип inputValue
    >(
        INIT_INPUT,
        handleSubmit,
        fabricTypeFormValidator, // Теперь сигнатуры совпадают
    );
    const isPlaceholderVisible = !isLoading && !error.isError && !isFormOpen && typesOfFabric?.length === 0;

    const modifedTypeOfFabric = typesOfFabric.map((fabricType) => {
        const productCount = products.filter((product) => product.fabricType?.id === fabricType.id).length;
        const discountedProductsCount = products.filter((product) => product.fabricType?.id === fabricType.id && product.discount).length;

        return {
            ...fabricType,
            productsCount: productCount,
            discountedProductsCount,
        };
    });

    useEffect(() => {
        if (!fabricTypeToBeEdited.id) return;

        setInput((prev) => ({
            ...prev,
            ...fabricTypeToBeEdited,
        }));
    }, [fabricTypeToBeEdited, setInput]);

    function handleSubmit() {
        const name = input.name.trim();
        const description = input.description.trim();
        const url = input.url.trim();
        if (fabricTypeToBeEdited.id) {
            const updatedFabricType = {
                ...fabricTypeToBeEdited,
                ...input,
                url,
            };
            dispatch(updateAllProductsTypesOfFabric(updatedFabricType));
            dispatch(updateFabricType(updatedFabricType));
        } else {
            const newFabricType = {
                name,
                description,
                url,
            };

            dispatch(createFabricType(newFabricType));
        }
        closeForm();
    }

    const openForm = () => {
        setIsFormOpen(true);
    };

    const closeForm = () => {
        setIsFormOpen(false);
        dispatch(removeSelectedFabricType());
        resetForm();
    };

    const deleteFabricTypeHendler = async (id: FabricType['id']) => {
        const hasProducts = modifedTypeOfFabric.some((fabricType) => fabricType.id === id && fabricType.productsCount > 0);

        if (hasProducts) {
            dispatch(showAlert({ type: AlertType.Error, message: DELETE_FABRICTYPE_ALERT_MESSAGE }));

            return;
        }
        dispatch(deleteFabricType(id));
    };

    const editFabricTypeHandler = (id: FabricType['id']) => {
        dispatch(selectFabricType(id));
        openForm();
    };

    return (
        <Card>
            <div className={classes.fabricType}>
                <div className={classes.header}>
                    <h3 className={classes.title}>Типы ткани</h3>

                    <IconButton onClick={openForm} isDisabled={isFormOpen || error.isError}>
                        <AddIcon />
                    </IconButton>
                </div>

                {isLoading && <AreaLoader />}

                {!isLoading && error.isError && !isFormOpen && <Placeholder text={error.message} size={'32px'} />}

                {isPlaceholderVisible && !error.isError && <Placeholder text={NO_TYPESOFFABRIC_MESSAGE} size={'32px'} />}

                {isFormOpen && (
                    <SettingsForm
                        onClose={closeForm}
                        onChange={handleChange}
                        onSubmit={submit}
                        errors={errors}
                        value={input}
                        labelName={'Название фильтра'}
                        labelURL={'SEO URL'}
                        namePlaceholder={'Укажите название фильтра'}
                        descriptionPlaceholder={'Описание фильтра'}
                    />
                )}

                {!isFormOpen && typesOfFabric?.length > 0 && (
                    <SettingsList items={modifedTypeOfFabric} onEdit={editFabricTypeHandler} onDelete={deleteFabricTypeHendler} />
                )}
            </div>
        </Card>
    );
};

export default TypeOfFabric;
